export class CenterlinkCardFormModel {
    hasCentrelinkCard: boolean = null;
    centrelinkNumber: number = null;
    constructor(obj: CenterlinkCardFormModel = null) { if (obj) { Object.assign(this, obj); } }
}
